<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <v-card>
        <v-card-title>
          {{ `${$t('menu.gestion')} / ${$t('menu.finanzas')}` }}
        </v-card-title>
        <v-card-text><FinanzasList /></v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import FinanzasList from './tablas/FinanzasList.vue'

export default {
  components: {
    FinanzasList,
  },
  data() {
    return {}
  },
}
</script>
